/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { CLabel } from '@coreui/react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import classNames from 'classnames';
import './styles.scss';

const SyncSelect = ({
  isMulti,
  isSearchable,
  value,
  defaultOptions,
  onChange,
  label,
  ...props
}) => {
  const darkMode = useSelector((state) => state.base.darkMode);
  const handleSelect = (selectedVal, { name }) => {
    onChange(selectedVal, name);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 3,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: 35,
    }),
    valueContainer: (provided) => ({
      ...provided,
    }),
    indicatorContainer: (provided) => ({
      ...provided,
      padding: '6px',
    }),
  };

  return (
    <>
      {label && (<CLabel>{label}</CLabel>)}
      <Select
        isMulti={isMulti}
        isSearchable={isSearchable}
        options={defaultOptions}
        defaultValue={value}
        onChange={handleSelect}
        theme={(theme) => ({
          ...theme,
          height: 35,
          colors: {
            ...theme.colors,
            primary: darkMode ? 'black' : theme.colors.primary,
            primary25: darkMode ? 'black' : theme.colors.primary25,
            primary50: darkMode ? 'black' : theme.colors.primary50,
            primary75: darkMode ? 'black' : theme.colors.primary75,
            dangerLight: darkMode ? 'black' : theme.colors.dangerLight,
            neutral0: darkMode ? '#2a2b36' : theme.colors.neutral0,
            neutral5: darkMode ? 'white' : theme.colors.neutral5,
            neutral10: darkMode ? 'white' : theme.colors.neutral10,
            neutral20: darkMode ? 'white' : theme.colors.neutral20,
            neutral30: darkMode ? 'white' : theme.colors.neutral30,
            neutral40: darkMode ? 'white' : theme.colors.neutral40,
            neutral50: darkMode ? 'white' : theme.colors.neutral50,
            neutral60: darkMode ? 'white' : theme.colors.neutral60,
            neutral70: darkMode ? 'white' : theme.colors.neutral70,
            neutral80: darkMode ? 'white' : theme.colors.neutral80,
            neutral90: darkMode ? 'white' : theme.colors.neutral90,
          },
        })}
        styles={customStyles}
        className={classNames(['mxw-100-xs multiselect'])}
        noOptionsMessage={() => 'No options'}
        {...props}
      />
    </>
  );
};

SyncSelect.propTypes = {
  isMulti: PropTypes.bool,
  isSearchable: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  defaultOptions: PropTypes.arrayOf(PropTypes.shape()),
  label: PropTypes.string,
};

SyncSelect.defaultProps = {
  isMulti: false,
  isSearchable: true,
  onChange: null,
  value: '',
  defaultOptions: null,
  label: '',
};

export default SyncSelect;
